import { useRouter } from 'next/router';
import Head from 'next/head';
import { request, utils } from 'lib';
import { useSetState } from 'react-hanger';
import { useEffect } from 'react';

import kefuImg from './images/group-3.png';
import kefuImg2 from './images/group-4.png';

import helpStyle from './static/help.module.scss';
import { LoadingBlock } from 'components';
const a = helpStyle.a;

const Index = (props) => {
  const helpId = useRouter().query.id;

  const {
    state: { data, count },
    setState,
  } = useSetState({});

  useEffect(() => {
    if (helpId) {
      request.api
        .get(`public/notice/${helpId}`, {
          page: 1,
          size: 12,
        })
        .then((res) => {
          setState({
            data: res.data,
            count: res.count || res.rows,
          });
        });

      import('./static/help');
    }
  }, [helpId]);

  if (!data) {
    return <LoadingBlock page></LoadingBlock>;
  }

  return (
    <div className=" container">
      <Head>
        <title>帮助中心_么么直播_美女视频直播秀场</title>

        <meta content="柠檬,客服,明星等级,富豪等级,么么直播" name="keywords" />
        <meta
          content="么么直播的帮助中心，客服联系方式，什么是柠檬、什么是明星等级、什么是富豪等级。"
          name="description"
        />
        <script src="//lib.sumeme.com/base/scripts/ui/pagination/pagination.js"></script>
      </Head>
      <div className="body">
        <div className="body-bd fix">
          <div className="body-bd-side">
            <div className="help-tags">
              <ul>
                <li>
                  <a className={helpId == 7 ? 'active' : ''} href="/help/7" data-nam="7">
                    管理规范
                  </a>
                </li>
                <li>
                  <a className={helpId == 0 ? 'active' : ''} href="/help/0" data-nam="0">
                    平台公告
                  </a>
                </li>
                <li>
                  <a className={helpId == 8 ? 'active' : ''} href="/help/8" data-nam="8">
                    活动中心
                  </a>
                </li>
                <li>
                  <a className={helpId == 1 ? 'active' : ''} href="/help/1" data-nam="1">
                    帮助中心
                  </a>
                </li>
              </ul>
            </div>
            <div className="help-qq"></div>
          </div>
          <div className="body-bd-main">
            <ul id="j_help_list">
              {data.map((item) => {
                return (
                  <li key={item._id}>
                    <a
                      href={item.click_url ? item.click_url : `/notice/${item._id}`}
                      target="_blank"
                    >
                      {item.title}
                      <i>{utils.formatTime(item.timestamp, 'yyyy-MM-dd')}</i>
                    </a>
                  </li>
                );
              })}
            </ul>
            <div className="ui-pager" data-count={count}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
